module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet portlet-participants box grey-cascade"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped m-b-0"
  }, [_c('tbody', _vm._l((_vm.users), function(mgu) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(mgu.user.name))])])
  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group m-b-0"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "for": "participant"
    }
  }, [_vm._v("Adicionar participante")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newParticipant),
      expression: "newParticipant"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "participant",
      "id": "participant",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newParticipant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.participants), function(participant, index) {
    return _c('optgroup', {
      attrs: {
        "label": participant.title
      }
    }, _vm._l((participant.list), function(value) {
      return _c('option', {
        domProps: {
          "value": value.userId
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(value.formatedName) + "\n\t\t\t\t\t\t\t")])
    }))
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdicionar\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Participantes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8047c2cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-users/main.vue
// module id = 1093
// module chunks = 1